const key = 'language';

export const setLanguage = language => {
  return window.localStorage.setItem(key, language);
};

export const getLanguage = () => {
  return window.localStorage.getItem(key) || 'en';
};
